<template>
    <div class="computerBox">
        <topBox :title="$route.meta.title" />
        <div class="px-[36px] w-full mt-[80px] pb-[70px]">

            <!-- 余额概览 -->
            <div class="my-2">
                <div class="flex flex-col items-center rounded-[24px] border bg-white px-[35px] py-[20px] shadow-lg">
                    <div class="text-xs text-slate-400">{{ $t('text.AccountBalance') }}</div>
                    <div class="mt-2 text-m14 font-semibold text-slate-900">¥&nbsp;{{ displayBalance }}</div>
                    <!-- <div class="mt-2 flex w-full justify-between text-14 text-slate-400">
                        <span>TRX {{ api.trx_balance }}</span>
                        <span>USDT {{ api.usdt_balance }}</span>
                    </div> -->
                </div>
            </div>

            <!-- 提款方式 -->
            <div class="my-3">
                <h1 class="text-m14 font-semibold text-slate-900 mb-[10px]">{{ $t('text.withdrawMethod') }}</h1>
                <div class="grid grid-cols-2 gap-3">
                    <button
                        v-for="item in withdrawTypes"
                        :key="item.id"
                        type="button"
                        class="pay-type-btn"
                        :class="{ 'pay-type-btn--selected': type === item.id }"
                        @click="selectType(item.id)"
                    >
                        {{ $t('text.' + item.name) }}
                    </button>
                </div>
            </div>

            <!-- 提款金额 -->
            <div class="my-3">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('revision.withdrawalAmount') }}</h1>
                <input
                    type="number"
                    min="1"
                    step="1"
                    class="block w-full px-[35px] py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1 focus:outline-none text-ms"
                    :placeholder="$t('placeholder.withdrawalAmount')"
                    v-model="amount"
                />
                <p class="mt-2 text-14 text-slate-400 px-2">
                    {{ $t('text.withdrawAvailable') }}：¥&nbsp;{{ availableBalance }}
                </p>
            </div>

            <div class="py-[10px]">
                <button
                    type="button"
                    class="block w-full px-3 py-[15px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                    :disabled="submitting"
                    @click="onSubmit"
                >
                    {{ submitting ? $t('text.buying') : $t('but.continue') }}
                </button>
            </div>

            <div class="pb-[10px]">
                <router-link
                    to="/computer/withdraw/list"
                    class="block w-full px-3 py-[15px] border rounded-full bg-white text-slate-700 shadow-lg text-center text-xs-xs no-underline"
                >
                    {{ $t('text.withdrawRecord') }}
                </router-link>
            </div>

            <p class="mt-2 fz12 text-slate-400 leading-relaxed text-center">{{ $t('text.withdrawTip') }}</p>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import axios from 'axios'
import { layer } from 'vue3-layer'

export default {
    components: {
        topBox,
        mainMenu,
    },
    data() {
        return {
            lang: '',
            submitting: false,
            type: null,
            amount: '',
            api: {
                balance: 0,
                trx_balance: 0,
                usdt_balance: 0,
                monthCommission: 0,
                total_commission: 0,
                total_withdraw_commission: 0,
            },
            // 与 withdraw.sql 一致：0=trx 1=usdt 3=支付宝 4=微信
            withdrawTypes: [
                // { id: 0, name: 'withdrawTrx' },
                // { id: 1, name: 'withdrawUsdt' },
                { id: 3, name: 'payAlipay' },
                { id: 4, name: 'payWxpay' },
            ],
        }
    },
    computed: {
        displayBalance() {
            // 先将帐户的“可用余额”和“本月部下分润”转换为浮点数，然后相加，最后保留2位小数
            // 这里还是先减掉本月已提现的金额，需要一个新接口，得到当前帐号本月应得佣金，及当前月已申请提现的金额。
            let balance = (parseFloat(this.api.balance) + parseFloat(this.api.total_commission) - parseFloat(this.api.total_withdraw_commission)).toFixed(2)
            // 如果余额小于0，或余额不是数字，则余额为0.00。原因是，前面用于计算的三个数值，是通过 API 接口向后端请求的，后端数据还没有返回时，这三个数值如果没有事先赋值，则会出现 NaN。
            // 所以做一下判断，如果余额小于0，或余额不是数字，则余额为0.00。
            if (balance < 0 || isNaN(balance)) balance = '0.00'
            return balance
        },
        availableBalance() {
            if (this.type === 0) return this.api.trx_balance
            if (this.type === 1) return this.api.usdt_balance
            // 先将帐户的“可用余额”和“本月部下分润”转换为浮点数，然后相加，最后保留2位小数
            // 这里还是先减掉本月已提现的金额，需要一个新接口，得到当前帐号本月应得佣金，及当前月已申请提现的金额。
            let balance = (parseFloat(this.api.balance) + parseFloat(this.api.total_commission) - parseFloat(this.api.total_withdraw_commission)).toFixed(2)
            // 如果余额小于0，或余额不是数字，则余额为0.00。原因是，前面用于计算的三个数值，是通过 API 接口向后端请求的，后端数据还没有返回时，这三个数值如果没有事先赋值，则会出现 NaN。
            // 所以做一下判断，如果余额小于0，或余额不是数字，则余额为0.00。
            if (balance < 0 || isNaN(balance)) balance = '0.00'
            return balance
        },
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang

        this.getCommission()
    },
    methods: {
        selectType(id) {
            this.type = id
        },
        getCommission() {
            axios.get(
                '/api/m/withdraw/commission',
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token'),
                    }
                }
            )
            .then((response) => {
                if (response.data.code === 0) {
                    this.api.balance = response.data.data.balance || 0 // 帐户余额
                    this.api.total_commission = response.data.data.total_commission || 0  // 本月部下分润
                    this.api.total_withdraw_commission = response.data.data.total_withdraw_commission || 0 // 本月已申请提现的佣金总额
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },

        // 提交提款申请
        onSubmit() {
            if (this.submitting) return
            if (this.type === null || this.type === undefined || this.type === '') {
                layer.msg(this.$t('text.withdrawSelectType'))
                return
            }
            const amount = Number(this.amount)
            if (!amount || amount < 100) {
                layer.msg(this.$t('text.withdrawAmountInvalid'))
                return
            }
            if (amount > Number(this.availableBalance)) {
                layer.msg(this.$t('text.withdrawBalanceNotEnough'))
                return
            }

            this.submitting = true
            axios.post(
                '/api/m/make/withdraw',
                {
                    type: this.type,
                    amount: Math.floor(amount),
                },
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        token: localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                this.submitting = false
                layer.msg(response.data.msg)
                if (response.data.code === 0) {
                    this.amount = ''
                    this.getCommission()
                }
            })
            .catch((error) => {
                this.submitting = false
                console.log(error)
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
}

.pay-type-btn {
    padding: 14px 8px;
    border-radius: 20px;
    border: 1px solid #e5e7eb;
    background: #fff;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
    font-size: 13px;
    color: #334155;
    text-align: center;
}

.pay-type-btn--selected {
    border-color: #22c55e;
    color: #16a34a;
    background: #f0fdf4;
    font-weight: 600;
}
</style>
